export default {"src":"/_next/static/media/vector-one.6d67e4c1.svg","height":173,"width":53};